









































import { Component, Vue } from 'vue-property-decorator'
import { querySelfExam } from '@/api/api'
import moment from 'moment'
import axios from 'axios'

@Component({})
export default class Exam extends Vue {
  examData: Array<any> = []
  examLists: Array<any> = []
  pageSize: number = 10 // 分页组件的page-size
  total: number = 0 // 分页组件的total

  examId: any = ''

  dialogVisible: boolean = false

  mounted() {
    this._querySelfExam()
  }

  /**
   * 开始考试
   */
  examHint(e: any): void {
    this.dialogVisible = true
    this.examId = e.id
  }

  startExam(): void {
    this.$router.push({ path: '/TestPaper', query: { id: this.examId } })
  }

  examDetail(index: number): void {
    sessionStorage.setItem('examDetail', JSON.stringify(this.examLists[index]))
    this.$router.push({ path: '/ExamDetail'})
  }

  /**
   * 换页
   */
  changePage(page: number): void {
    // this._querySelfShare(page)
  }

  _querySelfExam(): void {
    const load = this.$loading({
      lock: true,
      text: '加载中',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    querySelfExam()
      .then((res: any) => {
        console.log(res)
        if (res.data.code === 101) {
          this.examLists = res.data.result
          const arr = res.data.result
          for (let i = 0, len = arr.length; i < len; i++) {
            if (arr[i].exam_type === 0) {
              this.examData.push({
                id: arr[i].exam_history_id,
                name: arr[i].exam_name,
                startTime: moment(arr[i].start_time).format('YYYY.MM.DD'),
                endTime: moment(arr[i].end_time).format('YYYY.MM.DD'),
                state: arr[i].status ? this._stateToCn(arr[i].status) : '未开始',
                score: arr[i].score,
                isPass: this._isPassToCn(arr[i].isPass)
              })
            }
          }
        }
        load.close()
      })
      .catch(_ => {
        load.close()
      })
  }

  /**
   *  状态值转译成中文
   */
  _stateToCn(state: 0 | 1 | 2): any {
    const Dic = {
      0: '未开始',
      1: '未阅卷',
      2: '已阅卷'
    }
    return Dic[state]
  }

  /**
   *  状态值转译成中文
   */
  _isPassToCn(isPass: number): string {
    return isPass === 0 ? '未通过' : '已通过'
  }
}
